// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__A7fKi","loaderWhite":"Loader_loaderWhite__t2aiR","loader-white":"Loader_loader-white__400jV"};